import { isYes } from 'helpers';

import { OnboardingSettingsFormType } from '../forms/onboardingSettingsForm';

export const getSubmitData = (values: OnboardingSettingsFormType) => ({
  isAutomaticPersonalAccountGenerationEnabled: isYes(
    values.isAutomaticPersonalAccountGenerationEnabled
  ),
});
